import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataTrackableInterface } from '../data/trackable.interface';
import { GtmStatsAdapterEcommerceProductView } from './ecommerce-product-view';
import { GtmStatsAdapterEcommerceCheckout } from './ecommerce-checkout';

export class GtmStatsAdapterEntityPage implements StatsAdapterInterface {
  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataTrackableInterface[] {
    return [
      new GtmStatsAdapterEcommerceProductView(this.entity, this.context).getData(),
      new GtmStatsAdapterEcommerceCheckout(this.entity, this.context).getData(),
    ];
  }
}
